import { createFileRoute, redirect } from '@tanstack/react-router';

import { CoursesPage } from '@/pages/courses';

export const Route = createFileRoute('/_user/courses/')({
  component: CoursesPage,
});
